memoryBank.factory('MyMemoriesResource', ['$resource', ($resource) ->
  $resource "",{},
    query:
      method: 'GET'
      isArray: false
      url: APIRoutes.v2_my_memories_path()
])
